// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.review__entry[data-v-67601940] {

    margin-right: 0.5rem;

    display: flex;

    min-width: 20rem;

    flex-direction: column;

    border-radius: 12px;

    border-width: 1px;

    --tw-border-opacity: 1;

    border-color: rgb(229 231 235 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity));

    padding: 1rem
}
@media (min-width: 996px) {
.review__entry[data-v-67601940] {

        margin-right: 0;

        min-width: 0px;

        border-width: 0px;

        border-style: none;

        --tw-bg-opacity: 1;

        background-color: rgb(243 244 246 / var(--tw-bg-opacity));

        padding: 0;

        padding-right: 1rem
}
}
@media (min-width: 1320px) {
.review__entry[data-v-67601940] {

        margin-right: 0.25rem;

        padding-right: 0
}
}
.review__entry__content[data-v-67601940] {

    display: flex;

    flex-direction: row
}
.review__entry__content img[data-v-67601940] {

    margin-right: 0.5rem;

    height: 2.5rem;

    width: 2.5rem
}
@media (min-width: 996px) {
.review__entry__content img[data-v-67601940] {

        margin-right: 1rem;

        height: 3rem;

        width: 3rem
}
}
.review__entry__wrapper[data-v-67601940] {

    width: 100%
}
.review__entry__name[data-v-67601940] {

    --tw-text-opacity: 1;

    color: rgb(17 24 39 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 700
}
@media (min-width: 996px) {
.review__entry__name[data-v-67601940] {

        font-family: Roboto;

        line-height: 1.35;

        font-size: 1.125rem;

        font-weight: 700
}
}
.review__entry__number[data-v-67601940] {

    --tw-text-opacity: 1;

    color: rgb(156 163 175 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
@media (min-width: 996px) {
.review__entry__number[data-v-67601940] {

        font-family: Roboto;

        line-height: 1.5;

        font-size: 1rem;

        font-weight: 400
}
}
.review__entry__details[data-v-67601940] {

    margin-top: 0.5rem;

    display: flex
}
.review__entry__rate[data-v-67601940] {

    position: relative;

    display: inline-flex;

    justify-content: space-around
}
.review__entry__rate__icon[data-v-67601940] {

    margin: .125rem;

    flex-shrink: 0;

    display: inline-block;

    background-size: contain;

    background-repeat: no-repeat;

    width: 1rem;

    height: 1rem;

    background-image: url("/img/web/icons/star.svg")
}
.review__entry__rate__last-reviewed[data-v-67601940] {

    margin-left: 0.75rem;

    --tw-text-opacity: 1;

    color: rgb(156 163 175 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
@media (min-width: 996px) {
.review__entry__rate__last-reviewed[data-v-67601940] {

        font-family: Roboto;

        line-height: 1.5;

        font-size: 1rem;

        font-weight: 400
}
}
.review__review[data-v-67601940] {

    margin-top: 0.75rem;

    overflow: hidden;

    display: -webkit-box;

    -webkit-box-orient: vertical;

    -webkit-line-clamp: 5;

    text-overflow: ellipsis;

    --tw-text-opacity: 1;

    color: rgb(17 24 39 / var(--tw-text-opacity));

    font-family: Roboto;

    line-height: 1.5;

    font-size: 0.875rem;

    font-weight: 400
}
@media (min-width: 996px) {
.review__review[data-v-67601940] {

        margin-top: 1.5rem;

        margin-left: 4rem;

        overflow: hidden;

        display: -webkit-box;

        -webkit-box-orient: vertical;

        -webkit-line-clamp: 4;

        font-family: Roboto;

        line-height: 1.35;

        font-size: 1.125rem;

        font-weight: 400
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/home/reviews/Review.vue"],"names":[],"mappings":";AAkDA;;IAAA,oBAAA;;IAAA,aAAA;;IAAA,gBAAA;;IAAA,sBAAA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,eAAA;;QAAA,cAAA;;QAAA,iBAAA;;QAAA,kBAAA;;QAAA,kBAAA;;QAAA,yDAAA;;QAAA,UAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,qBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,aAAA;;IAAA;AAAA;AAGA;;IAAA,oBAAA;;IAAA,cAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,kBAAA;;QAAA,YAAA;;QAAA;AAAA;AAAA;AAKA;;IAAA;AAAA;AAIA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,mBAAA;;QAAA,iBAAA;;QAAA,mBAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,oBAAA;;IAAA,gDAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,mBAAA;;QAAA,gBAAA;;QAAA,eAAA;;QAAA;AAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA;AAAA;AAIA;;IAAA,kBAAA;;IAAA,oBAAA;;IAAA;AAAA;AAGA;;IAAA,eAAA;;IAAA,cAAA;;IAAA,qBAAA;;IAAA,wBAAA;;IAAA,4BAAA;;IAAA,WAAA;;IAAA,YAAA;;IAAA;AAAA;AAIA;;IAAA,oBAAA;;IAAA,oBAAA;;IAAA,gDAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,mBAAA;;QAAA,gBAAA;;QAAA,eAAA;;QAAA;AAAA;AAAA;AAMA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,oBAAA;;IAAA,4BAAA;;IAAA,qBAAA;;IAAA,uBAAA;;IAAA,oBAAA;;IAAA,6CAAA;;IAAA,mBAAA;;IAAA,gBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,kBAAA;;QAAA,iBAAA;;QAAA,gBAAA;;QAAA,oBAAA;;QAAA,4BAAA;;QAAA,qBAAA;;QAAA,mBAAA;;QAAA,iBAAA;;QAAA,mBAAA;;QAAA;AAAA;AAAA","sourcesContent":["<template>\n  <div class=\"review__entry\">\n    <div class=\"review__entry__content\">\n      <ImageComponent :src=\"`img/web/mocked-reviews-images/${review.image}.webp`\" alt=\"Imagen de perfil\" width=\"40\"></ImageComponent>\n      <div class=\"review__entry__wrapper\">\n        <p class=\"review__entry__name\">\n          {{ review.name }}\n        </p>\n        <p class=\"review__entry__number\">\n          {{ review.numberOfReviews }}\n        </p>\n        <div class=\"review__entry__details\">\n          <div class=\"review__entry__rate\">\n            <i class=\"review__entry__rate__icon\"></i>\n            <i class=\"review__entry__rate__icon\"></i>\n            <i class=\"review__entry__rate__icon\"></i>\n            <i class=\"review__entry__rate__icon\"></i>\n            <i class=\"review__entry__rate__icon\"></i>\n          </div>\n          <span class=\"review__entry__rate__last-reviewed\">\n            {{ review.whenLastReview }}\n          </span>\n        </div>\n      </div>\n    </div>\n    <p class=\"review__review\">\n      {{ review.review }}\n    </p>\n  </div>\n</template>\n\n<script>\nimport ImageComponent from '@/lego/components/images/Image.vue';\n\nexport default {\n  components: {\n    ImageComponent,\n  },\n  props: {\n    review: {\n      type: Object,\n      required: true,\n    },\n  },\n};\n</script>\n\n<style scoped lang=\"postcss\">\n.review {\n  &__entry {\n    @apply flex flex-col rounded-md mr-nano lg:mr-0 xl:mr-quark p-xxxs lg:p-0 lg:pr-xxxs xl:pr-0 lg:border-none border-hairline border-neutral-light lg:bg-neutral-lightest bg-neutral-white min-w-[20rem] lg:min-w-0;\n\n    &__content {\n      @apply flex flex-row;\n\n      img {\n        @apply w-sm h-sm mr-nano lg:w-md lg:h-md lg:mr-xxxs;\n      }\n    }\n\n    &__wrapper {\n      @apply w-full;\n    }\n\n    &__name {\n      @apply style-overline-bold lg:style-body-bold text-neutral-ultradark;\n    }\n\n    &__number {\n      @apply style-overline lg:style-body-sm text-neutral-medium;\n    }\n\n    &__details {\n      @apply flex mt-nano;\n    }\n\n    &__rate {\n      @apply relative inline-flex justify-around;\n\n      &__icon {\n        @apply icon icon-xxxs icon-star m-[.125rem];\n      }\n\n      &__last-reviewed {\n        @apply text-neutral-medium lg:style-body-sm ml-micro style-overline;\n      }\n    }\n  }\n\n  &__review {\n    @apply mt-micro lg:mt-xxs text-neutral-ultradark style-overline lg:style-body text-ellipsis line-clamp-5 lg:line-clamp-4 lg:ml-xl;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
